import AbstractSmsTemplatesEditorPageCtrl from "./abstract-editor";

export default class SmsTemplatesCreatePageController extends AbstractSmsTemplatesEditorPageCtrl {
    constructor($scope, $injector) {
        super($scope, $injector)

        this.headline = this.translate.instant(`messages.controllers.pages.sms.templates.create.title`)
    }

    async handleSubmitData() {
        return this.api.post('messages/sms/templates', this.model)
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/controllers/pages/sms/templates/create.js